import type { ColorID } from "@pdfking/renderer-api"

import { PALETTE } from "#constants"

/** The color a calendar sets a day's number in: a working day's the text's,
 * a holiday's — a Sunday — the primary, a day of the month before or after
 * `muted`, as faint as the lines. Monday is `weekday` 0. */
export const DayColor = (weekday: number, muted = false): ColorID =>
  muted ? PALETTE.lines : weekday === 6 ? PALETTE.primary : PALETTE.text
